import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { GuestPageWrapper } from 'src/components/PageWrapper'
import { LargeButton } from 'src/elements/Button'
import { Link } from 'src/elements/Link'
import { AuthService } from 'src/services/AuthService'
import {
  lightgray,
  truewhite,
  _menuhover,
  safetyOrange,
} from 'src/styles/colors'
import { fontWeightBold, fontWeightRegular } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import { FORGOT_ID_AND_PASSWORD_URL } from 'src/utils/routes'
import styled from 'styled-components'
import { FormInput } from '../Profile/formComponents'

type ForgotPasswordFormData = {
  email: string
}
export const ForgotPassword = () => {
  const methods = useForm<ForgotPasswordFormData>()
  const {
    handleSubmit,
    formState: { isSubmitSuccessful, isSubmitting },
  } = methods
  const submit = async (data: ForgotPasswordFormData) =>
    AuthService.resetPasswordRequest(data.email)

  useEffect(() => {
    AuthService.initialize()
  }, [])

  return (
    <GuestPageWrapper>
      <Content>
        <h1>パスワードをお忘れの方は...</h1>
        <p>
          以下にメールアドレスをご記入の上、「再発行」ボタンを押してください。
        </p>
        <p>
          パスワード再設定のご案内をお送りします。ID・パスワードをどちらもお忘れの方は、
          <Link href={FORGOT_ID_AND_PASSWORD_URL}>こちら</Link>{' '}
          からお問い合わせください
        </p>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(submit)}>
            <FormInput
              id="email"
              label="決裁者メールアドレス"
              type="email"
              autoComplete="email"
            />
            {!isSubmitSuccessful ? (
              <SubmitButton disabled={isSubmitting}>再発行</SubmitButton>
            ) : (
              <Message>パスワード再設定のご案内メールを送信しました。</Message>
            )}
          </Form>
        </FormProvider>
        <Links>
          <Link href={FORGOT_ID_AND_PASSWORD_URL}>
            ID・パスワードが両方わからない方はこちら
          </Link>
        </Links>
      </Content>
    </GuestPageWrapper>
  )
}

const Message = styled.p`
  font-size: 18px;
  text-align: center;
`
const Links = styled.div`
  ${flexCenter};
  flex-direction: column;
  line-height: 1.5;
`

const Form = styled.form`
  width: 100%;
  label {
    font-weight: ${fontWeightBold};
  }
`

const SubmitButton = styled(LargeButton)`
  color: ${truewhite};
  background: ${safetyOrange};
  min-width: 232px;
`

const Content = styled.div`
  margin: 48px auto;
  padding: 64px 48px;
  max-width: 1024px;
  ${flexCenter};
  flex-direction: column;
  font-weight: ${fontWeightBold};

  h1 {
    width: 100%;
    text-align: center;
    font-size: 26px;
    padding-bottom: 24px;
    margin-bottom: 24px;
    border-bottom: 1px solid ${lightgray}40;
  }
  p {
    line-height: 1.5;
  }
  ${SubmitButton},${Message} {
    display: block;
    margin: 64px auto 0;
  }
  ${Links} {
    margin-top: 24px;
    font-weight: ${fontWeightRegular};
  }
  a {
    :hover {
      text-decoration: underline;
      color: ${_menuhover};
    }
  }
  input {
    font-weight: ${fontWeightRegular};
  }
`
